import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

// THE CHECKOUT STRIP (Studio Blueprint 05-E): under every pay button, in the
// spec plate's mono style, how people can pay on THAT checkout and the name on
// their statement, so nobody meets it first on Stripe's page.
//
//   packs  credit packs: card (Apple Pay and Google Pay ride in under card),
//          Link and OXXO (shared/config/packs.js PAYMENT_METHOD_TYPES)
//   card   quick tools: card, with Apple Pay and Google Pay
//          (routes/quicktools.js payment_method_types ['card'])
//   storybook  card, Apple Pay, Google Pay and Link. Its checkout also asks
//          for OXXO, but the storybook page never names a currency
//          (Storybook.test.tsx), so OXXO is left off there.
//
// Read live on Stripe, 2026-10-16: Apple Pay, Google Pay and Link are on, and
// OXXO appears only to a buyer Stripe quotes in pesos (Adaptive Pricing drops
// it for every other currency). The chip stays plain: naming the currency
// would say where the money lands.
//
// Never say which country or bank the money reaches (owner rule).

const METHODS = {
  packs: ['card', 'applePay', 'googlePay', 'link', 'oxxo'],
  card: ['card', 'applePay', 'googlePay'],
  storybook: ['card', 'applePay', 'googlePay', 'link'],
} as const;

export function CheckoutStrip({ methods = 'card', className }: { methods?: keyof typeof METHODS; className?: string }) {
  const { t } = useTranslation();
  return (
    <div data-testid="checkout-strip" className={cn('mt-3 space-y-1.5 text-center font-mono text-[11.5px] tracking-wide text-muted-foreground', className)}>
      <ul className="flex flex-wrap items-center justify-center gap-1.5" aria-label={t('trust.strip.methods')}>
        <li className="rounded border border-foreground/15 px-1.5 py-0.5 text-foreground/80" translate="no">Stripe</li>
        {METHODS[methods].map((m) => (
          <li key={m} className="rounded border border-foreground/15 px-1.5 py-0.5" translate={m === 'oxxo' || m === 'link' ? 'no' : undefined}>
            {t(`trust.strip.${m}`)}
          </li>
        ))}
      </ul>
      <p>
        {t('trust.strip.statement')} <span className="font-semibold text-foreground/80" translate="no">FACESHOT CHOPSHOP</span>
      </p>
    </div>
  );
}
